/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiPoll } from './Poll';
import { ApiProduction } from './Production';
import { ApiCarouselSlide } from './CarouselSlide';
import { ApiArticle } from './Article';
import { ApiHomeRow } from './HomeRow';

export interface HomePageRequest {

    /**
     * Timestamp for when this page was cached.
     */
    cached_at?: Number;

    /**
     * Currently featured poll
     */
    poll?: ApiPoll;

    /**
     * Currently featured petition
     */
    petition?: ApiPoll;

    /**
     * Latest production of main show
     */
    main_show?: ApiProduction;

    carousel_slides?: ApiCarouselSlide[];

    podcasts?: ApiProduction[];

    episodes?: ApiProduction[];

    articles?: ApiArticle[];

    clips?: ApiProduction[];

    candidates?: ApiProduction[];

    rows?: ApiHomeRow[];

}

@Model('HomePage')
export class ApiHomePage extends BaseModel implements HomePageRequest {

    /**
     * Timestamp for when this page was cached.
     */
    
    
    cached_at: Number;

    /**
     * Currently featured poll
     */
    @Type('ApiPoll')
    @Expand()
    poll: ApiPoll;

    /**
     * Currently featured petition
     */
    @Type('ApiPoll')
    @Expand()
    petition: ApiPoll;

    /**
     * Latest production of main show
     */
    @Type('ApiProduction')
    @Expand()
    main_show: ApiProduction;

    @Type('ApiCarouselSlide')
    @Expand()
    carousel_slides: ApiCarouselSlide[];

    @Type('ApiProduction')
    @Expand()
    podcasts: ApiProduction[];

    @Type('ApiProduction')
    @Expand()
    episodes: ApiProduction[];

    @Type('ApiArticle')
    @Expand()
    articles: ApiArticle[];

    @Type('ApiProduction')
    @Expand()
    clips: ApiProduction[];

    @Type('ApiProduction')
    @Expand()
    candidates: ApiProduction[];

    @Type('ApiHomeRow')
    @Expand()
    rows: ApiHomeRow[];

}
